import { Component, OnInit } from '@angular/core';

import { Comment } from './comment';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit {

  comments: Comment[] = [];
  userComment: string;

  constructor() {}

  ngOnInit() {
    this.comments = [];
  }

  getBgImage(avatar) {
    return 'url(' + avatar + ') center center no-repeat';
  }

  setComment() {
    const time = new Date();
    this.comments.unshift({
      avatar: '/assets/img/users/anonim.jpg',
      name: 'Visitor',
      text: this.userComment,
      time: time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    });
    this.userComment = '';
  }

}



// WEBPACK FOOTER //
// /var/www/ras.universarium.org/www/src/app/comment/comment.component.ts